import type { TFunction } from "i18next";

export const CLIENT_CONFIG_NS = "athlete-portal";

/** Lowercase role label for copy that says "this client/athlete" (athlete-portal namespace). */
export function clientConfigRoleLabel(
  t: TFunction<typeof CLIENT_CONFIG_NS>,
  referAsClients: boolean
): string {
  return referAsClients ? t("programs.client") : t("programs.athlete");
}

/** Plural role for copy such as "other clients". */
export function clientConfigRolePlural(
  t: TFunction<typeof CLIENT_CONFIG_NS>,
  referAsClients: boolean
): string {
  return referAsClients
    ? t("clientConfiguration.roles.clients")
    : t("clientConfiguration.roles.athletes");
}

export type ClientConfigRoleLabels = {
  role: string;
  rolePlural: string;
};

export function clientConfigRoleLabels(
  t: TFunction<typeof CLIENT_CONFIG_NS>,
  referAsClients: boolean
): ClientConfigRoleLabels {
  return {
    role: clientConfigRoleLabel(t, referAsClients),
    rolePlural: clientConfigRolePlural(t, referAsClients),
  };
}

/** Lowercase role label when rendering from coaching-portal screens. */
export function clientConfigRoleLabelCoaching(
  t: TFunction<"coaching-portal">,
  referAsClients: boolean
): string {
  return referAsClients
    ? t("athletes.roleClientLower")
    : t("athletes.roleAthleteLower");
}
